export const POLICIES_UPDATED = "June 2026";

// Owner: replace the text below with your final legal copy. Each section renders as a heading + paragraphs.
export const POLICIES = [
  {
    id: "terms",
    title: "Terms of Service",
    paragraphs: [
      "By purchasing or using any Business Aligned product or service — including The Organizer, website builds and social media management plans — you agree to these terms.",
      "The Organizer is a one-time purchase that grants lifetime access to your personal workspace for as long as the service operates. Access is tied to your account and may not be shared or resold.",
      "Website builds and social media plans are delivered according to the scope described on the purchase page. Additional pages, features or revisions beyond that scope may be quoted separately.",
      "You retain ownership of the content, logos and brand assets you upload. You grant Business Aligned permission to use them solely to deliver your services.",
    ],
  },
  {
    id: "refunds",
    title: "Refund & Cancellation Policy",
    paragraphs: [
      "The Organizer: because it is a digital product with instant access, purchases are final once the workspace has been unlocked.",
      "Social media plans: billed monthly and can be cancelled at any time from your Account page. Cancellation stops the next renewal; the current month remains active until its end date.",
      "Website builds: a project may be cancelled before design work begins for a full refund. Once design has started, payments cover the work completed to date.",
    ],
  },
  {
    id: "privacy",
    title: "Privacy Policy",
    paragraphs: [
      "We collect only what is needed to run your account and deliver your services: your username, email, the content you add to your organizer, and uploaded brand assets.",
      "Payments are handled by Stripe. Business Aligned never sees or stores your full card details.",
      "Your organizer content is private to your account. The built-in AI copilot reads it only to personalize your answers and never uses it to train models.",
      "We do not sell your information. You may request deletion of your account and data at any time by contacting us through the inquiry form.",
    ],
  },
];
